<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Admin User Audit</div>
        <div>
          <bread-crumb :bread-crumbs="['Admin Audit']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="2" lg="2" xs="12">
            <!-- <label class="font-weight-large my-0">User Name</label> -->
            <v-text-field
              placeholder="User Name"
              v-model="username"
              :items="auditLogsList"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="2" lg="2" xs="12">
          <label class="font-weight-large my-0">To</label>
          <v-text-field type="date" dense outlined></v-text-field>
        </v-col> -->

          <div class="d-flex">
            <v-btn depressed 
              small
              class="text-capitalize"
              color="primary"
              @click="getUseraduitlogdata()"
              >Get Results</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
          :items="auditLogsList"
          dense
          class="mt-6"
        >
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Admin Audit",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    headers: [
      { text: "SNo", value: "_id", align: "start" },
      { text: "User Name", value: "user_name" },
      { text: "Label Name", value: "column_name" },
      { text: "Old Value", value: "old_value" },
      { text: "New Value", value: "new_value" },
      { text: "Modified By", value: "modified_by" },
      { text: "Modified Date", value: "modified_date", align: "center" },
    ],
    auditLogsList: [],
    loaderOverlay: false,
    search: "",
    username: "",
  }),
  mounted() {
    // this.getUseraduitlogdata();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getUseraduitlogdata() {
      this.loaderOverlay = true;
      try {
        const params = {
          username: this.username,
          skip: 0,
          limit: 50,
        };
        const response = await userService.getAdminuserlog(params);
        if (response.status === 200) {
          this.auditLogsList = response.data;
          console.log("auditLogsList", this.auditLogsList);
          this.stoploader();
        } 
        // else if (response.status === 401) {
        //   this.auditLogsList = [];
        //   this.returnNewToken();
        //   this.getUseraduitlogdata();
        //   this.stoploader();
        // } 
        else {
          this.auditLogsList == [];
          this.stoploader();
        }
      } catch (error) {
        this.auditLogsList = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
